export enum WithdrawOption {
  Crypto = 'crypto',
  PaypalRequest = 'paypalWithdrawRequest',
}
